module.exports = __webpack_public_path__ + "img/linkedin_tag.b4a41c92.jpg";